<template>
  <div>
    <!-- 时间级联组件 -->
    <a-time-picker @change="handleChangeStart" format="HH:mm" :disabled="timeDisable" v-decorator="['startTime']"></a-time-picker> ~
    <a-time-picker @change="handleChangeEnd" format="HH:mm" :disabled="timeDisable" v-decorator="['endTime']"></a-time-picker>
  </div>
</template>

<script>
import moment from "moment";
export default {
    name: "timePicker",
    zh: "可选起止时间",
    data() {
        return {
            timeStart: '00:00',
            timeEnd: '00:00',
            config1: {
                rules: [{ type: 'object', required: true, message: 'Please select time!' }],
            },
            config2: {
                rules: [{ type: 'object', required: true, message: 'Please select time!' }],
            },
        }
    },
    props: {
        timeDisable: {
            type: Boolean,
        }
    },
    methods: {
        handleChangeStart(time,timeString){
            this.timeStart = timeString
            this.$emit('timeStart',this.timeStart)
        },
        handleChangeEnd(time,timeString){
            this.timeEnd = timeString
            // this.$emit('timeEnd',{timeStart:this.timeStart,timeEnd:this.timeEnd})
            this.$emit('timeEnd',this.timeEnd)
        },
    },
    handleChangeEnd(time, timeString) {
      this.timeEnd = timeString;
      // this.$emit('timeEnd',{timeStart:this.timeStart,timeEnd:this.timeEnd})
      this.$emit("timeEnd", this.timeEnd);
    }
};
</script>

<style lang="scss" scoped>
.ant-time-picker {
  width: calc(50% - 8px);
}
</style>
